import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function TrendingGrid() {
  const trendingArticles = articles.filter((a) => a.isHot);
  const topArticle = trendingArticles.find((a) => a.isTop) || trendingArticles[0];
  const sideArticles = trendingArticles.filter((a) => a.id !== topArticle?.id).slice(0, 2);

  return (
    <section id="trending" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight">
              热门吃瓜
              <br />
              实时追踪
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-xs">
            全网热搜吃瓜内容，明星八卦、网红爆料一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-1">
            {topArticle && (
              <Link to={`/article/${topArticle.slug}`} className="block h-full">
                <ArticleCard
                  variant="featured"
                  id={topArticle.id}
                  title={topArticle.title}
                  excerpt={topArticle.excerpt}
                  category={topArticle.category}
                  categorySlug={topArticle.categorySlug}
                  imageUrl={topArticle.imageUrl}
                  date={topArticle.date}
                  views={topArticle.views}
                  tags={topArticle.tags}
                />
              </Link>
            )}
          </div>

          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {sideArticles.map((article) => (
              <Link key={article.id} to={`/article/${article.slug}`} className="block h-full">
                <ArticleCard
                  id={article.id}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  categorySlug={article.categorySlug}
                  imageUrl={article.imageUrl}
                  date={article.date}
                  views={article.views}
                  tags={article.tags}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}